module.exports = __webpack_public_path__ + "img/notif-empty.6887f781.svg";